var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile h-100"},[_c('transition',{attrs:{"name":"component-fade"}},[_c(_vm.visibleComponent,{tag:"component"},[(!_vm.isConnected)?_c('Pairing'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }